import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {Carousel} from "./carousel";

export const carouselLoader = function (options = {}) {
    componentLoader(componentConfig(Carousel, Carousel.config.componentTypeKey, Carousel.config.baseHtmlClass), options);
};